<template>
    <v-btn v-bind:style="teamNameStyle()" font-weight-bold depressed small>{{ team }}</v-btn>
</template>

<script>
import { useWhiteTextHex } from '../utils/colour-utils'

export default {
    props: ['team', 'colour', 'full_width', 'width'],
    methods: {
        teamNameStyle() {
            let styles = 'margin: 0px; text-transform: none; font-weight: bold;'

            if (this.colour) {
                if (useWhiteTextHex(this.colour)) {
                    styles += `background-color: ${this.colour}; color: #ffffff;`
                } else {
                    styles += `background-color: ${this.colour}; color: #000000;`
                }
            }

            if (this.full_width) {
                styles += `${styles} width: 100%;`
            } else if (this.width) {
                styles += `${styles} width: ${this.width};`
            }

            return styles
        }
    }
}
</script>

<style></style>
